import Vue from 'vue'
import DataService from '@/services/DataService'
import SharedService from '@/services/SharedService'

export default {
  // current node environment
  env: process.env.NODE_ENV,

  // Get all groups
  getAll() {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.Groups)
    } else {
      return Vue.http.get('groups')
        .then(SharedService.extractData)
    }
  },
  getMyGroups() {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.Groups)
    } else {
      return Vue.http.get('my_groups')
        .then(SharedService.extractData)
    }
  },
  getUserGroups(id) {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.Groups)
    } else {
      return Vue.http.get('user_groups/' + id)
        .then(SharedService.extractData)
    }
  },
  // Get all members for group id
  getGroupMembers(id) {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.GroupMembers)
    } else {
      return Vue.http.get('groups/members/' + id)
        .then(SharedService.extractData)
    }
  },
  // Get admin members for group id
  getGroupAdmins(id) {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.GroupMembers)
    } else {
      return Vue.http.get('groups/admins/' + id)
        .then(SharedService.extractData)
    }
  },

  // Join Group
  joinGroup(groupId, userId, roleId) {
    if (this.env === 'ci') {
      // TODO: needs updating
      return Promise.resolve(DataService.JoinGroup)
    } else {
      let data = {
        "group_id": groupId,
        "user_id": userId,
        "role_id": roleId
      };
      return Vue.http.post('groups/join/', data)
        .then(SharedService.extractData)
    }
  }
}
